import {required} from "vuelidate/lib/validators";  
const mzneposta = {
    data() { 
      return {  
         
        mznepostaData: { 
            Gonderenid: null,
            Aliciid: null,
            Creationtime: null,
            Message: null,
          
          }, 
          FormDataType:{
            Message:{FieldName:"Message",Field:"textarea",FieldTitle:this.$t('mzneposta.AddEdit.Message'),FieldType:"text"}, 
          } 
      }
    }, 
    validations:{ 
        FormData: {  
          Message: { required }, 
          
        }
   
    }
};


export default  mzneposta ;

